<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Fiche Assuré</strong>
      </b-card-header>
      <b-card-body>
        <b-row class="mb-2">
          <b-col md="3">
            Nom : {{ assure.nom }}
          </b-col>
          <b-col md="3">
            Prenom : {{ assure.prenom }}
          </b-col>
          <b-col md="3">
            NIR : {{ assure.nir }}
          </b-col>
          <b-col md="3">
            Date naissance : {{ assure.date_naissance }}
          </b-col>
        </b-row>
        <b-row v-if="beneficiaire" class="mt-5">
          <b-col>
            <a href="#" @click.prevent="ficheBeneficiaire(beneficiaire.id)">Cliquez ici pour accéder à la fiche
              bénéficiare</a>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th class="center"><b>SIREN</b></th>
                <th class="center"><b>Raison Sociale</b></th>
                <th class="center"><b>Famille Produits</b></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(element, key) in sirens" :key="key">
                <td><a href="#" @click.prevent="ficheSiren(element.siren, element.raison_sociale, element.oag, element.oap)">{{ element.siren
                  }}</a></td>
                <td><a href="#" @click.prevent="ficheSiren(element.siren, element.raison_sociale, element.oag, element.oap)">{{
                  element.raison_sociale }}</a></td>
                <td>{{element.famille_produit}}</td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row v-if="dossiers.length > 0" class="mt-5">
          <b-col>
            <span> {{ dossiers.length}} dossier(s) trouvé(s) : </span>
            <div v-for="(dossiers,key) in formattedDossiers" :key="key">
              <a class="ml-2" href="#" @click.prevent="rechercheDossier(dossiers[0])">
                {{ dossiers.length }} {{ key }}
              </a>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5" v-if="getIsEmpty(this.$route.query.from)">
          <b-col>
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des assurés
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

  import {getAccessToken, getBaseUrl, getIdToken, getProvider, getUser} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import {getMainTreatmentBasedOnType} from "@/utils/communHelper";

  export default {
    name: "Fiche",
    data() {
      return {
        nir: '',
        assure: {
          nom: '',
          prenom: '',
          nir: '',
          date_naissance: '',
        },
        beneficiaire: null,
        sirens: [],
        dossiers: [],
        allTraitements: [],
        formattedDossiers: [],
        dossiersReady: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getAllTraitements();
      this.user = getUser();
      this.userOags = this.user.profil_active[0].oags.map(oag => oag.code);
      this.userOaps = this.user.profil_active[0].oaps.map(oap => oap.code);
      let oag = this.$route.query.oag
      let oap = this.$route.query.oap
      if (this.userOags.indexOf(oag) > -1 && this.userOaps.indexOf(oap) > -1) {
        this.searchNir(this.$route.params.nir);
      } else {
        this.$swal({
          position: "top",
          type: "warning",
          title: "Attention !",
          text: 'Vous n\'avez pas les habilitations pour consulter cette fiche assuré',
          showConfirmButton: false,
          timer: 3000
        })
      }
    },
    watch: {
      '$route.params.nir'(nir) {
        this.searchNir(nir);
      }
    },
    methods: {
      searchNir(nir) {
        this.resetData();
        this.nir = nir;
        this.$axios
          .get('/recherche/globale/' + nir)
          .then(response => {
            this.sirens = response.data.data.assure;
            this.beneficiaire = response.data.data.beneficiaire;
            this.formatDossiers(response.data.data.dossiers);
            if (this.sirens.length > 0) {
              this.assure = this.sirens[0];
            } else if (this.beneficiaire !== null) {
              this.assure.nom = this.beneficiaire.nom;
              this.assure.prenom = this.beneficiaire.prenom;
              this.assure.nir = this.beneficiaire.nir;
              this.assure.date_naissance = this.formatDate(this.beneficiaire.date_naissance);
            }
          })
          .catch((error) => {
            console.log(error)
          });
      },
      ficheSiren(siren, raison_sociale, oag, oap) {
        window.open(`/espace-gestion/sirens/fiche/${siren}?rs=${raison_sociale}&oag=${oag}&oap=${oap}`, '_blank')
      },
      ficheBeneficiaire(beneficiaireId) {
        window.open(`/espace-beneficiaire/beneficiaires/fiche/${beneficiaireId}`, '_blank')
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      resetData() {
        this.assure = {
          nom: '',
          prenom: '',
          nir: '',
          date_naissance: '',
        };
        this.beneficiaire = null;
        this.sirens = [];
      },
      returnBack() {
        this.$router.push({ path: "/espace-gestion/assures/list",
          query: {
            do: this.$route.query.do,
            ns: this.$route.query.ns,
            no: this.$route.query.no,
            pr: this.$route.query.pr,
            siren: this.$route.query.siren,
            oag:this.$route.query.oag, 
            oap:this.$route.query.oap,
            source:this.$route.query.source,
          }
        })
      },
      formatDossiers(dossiers) {
        this.dossiers = dossiers.map( dossier => {
          dossier.idTraitement = this.getTraitementId(dossier);
          return dossier;
        });
        this.formattedDossiers = _.groupBy(this.dossiers, 'type.groupe')
      },
      getTraitementId(dossier) {
        let traitementId = '';
        if (!isEmpty(dossier.traitement_id)) {
          traitementId = dossier.traitement_id;
        } else {
          traitementId = this.getDossierTypeTraitement(dossier);
        }
        return traitementId;
      },
      getDossierTypeTraitement(dossier) {
        let traitementId = '';
        let mainTreatment = getMainTreatmentBasedOnType(dossier, this.allTraitements);
        
        traitementId = mainTreatment.id;
        return traitementId;
      },
      getAllTraitements() {
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.allTraitements = response.data.traitements;
          });
      },
      rechercheDossier(dossier) {
        // window.open(`/espace-gestion/dossier/dashboard?nir=${dossier.nir}&traitementId=${dossier.idTraitement}&page=1&limit=10&modeVisualisation=monActiviteProd`, '_blank');
        window.open(`/espace-gestion/dossier/dashboard?nir=${dossier.nir}&onlyOneCritere=nir&page=1&limit=10&modeVisualisation=monActiviteProd`, '_blank');
      },
      getIsEmpty(text) {
        return isEmpty(text)
      }
    }
  }
</script>
